import { Tooltip } from "@chakra-ui/react";
import ModalCode from "components/modals/ModalCode";
import React from "react";
import { useState } from "react";
import { FaCog, FaUpload, FaEye, FaInfoCircle } from "react-icons/fa";
import { Code as CodeType } from "@mijnfotohoek-types";
import Button from "components/forms/Button";
import { ModalPhoto } from "components/modals/ModalPhoto";

export const Code = ({
  code,
  getData,
}: {
  code: CodeType;
  getData?: () => void;
}) => {
  const [modal, setModal] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState<string | null>(null);
  return (
    <div>
      {modal && <ModalCode close={() => setModal(false)} code={code} />}
      <div className="grid md:grid-cols-[250px,1fr] gap-4 border-solid border-2 border-slate-200 rounded-2xl">
        {selectedPhoto != null && (
          <ModalPhoto
            close={() => setSelectedPhoto(null)}
            imageSrc={selectedPhoto}
          />
        )}
        <div className="px-6 py-4">
          <div className="flex items-center md:justify-start justify-center gap-2">
            <p className="text-lg font-bold">{code.id}</p>
            {/* @ts-ignore */}
          </div>
          <div className="flex gap-2">
            <Tooltip label="Details van deze code" hasArrow>
              <Button
                onClick={() => setModal(true)}
                size="text-md"
                isButtonIcon={true}
              >
                <FaCog />
              </Button>
            </Tooltip>
            {/* <Tooltip label="Foto('s) uploaden aan deze QR-code" hasArrow>
              <Button
                onClick={() => setModal(true)}
                size="text-md"
                isButtonIcon={true}
              >
                <FaUpload />
              </Button>
            </Tooltip> */}
            <Button
              size="text-md"
              className={` h-8 px-2`}
              color={
                code.downloads.length > 0
                  ? "text-green-500 bg-green-100"
                  : "text-gray-500 bg-gray-100"
              }
            >
              <FaEye />{" "}
              <span className="text-sm">{code.downloads.length}x</span>
            </Button>
          </div>
        </div>
        <div className="bg-slate-200 p-4 h-full w-full rounded-2xl  flex flex-wrap gap-2">
          {code.photos.length === 0 && (
            <p className="py-3 text-sm self-center  text-gray-600 font-bold">
              <FaInfoCircle className="inline mr-2" /> Deze code heeft nog geen
              foto's
            </p>
          )}
          {code.photos.map((p, i) => (
            <img
              src={p.url_thumb ?? p.url}
              key={i}
              className="w-20 h-20 rounded-2xl object-fill cursor-pointer"
              alt=""
              onClick={() => setSelectedPhoto(p.url ?? p.url_thumb)}
            />
          ))}
          {code.expired && (
            <div>
              <p className="text-sm text-orange-500 bg-orange-100 p-2 rounded-lg">
                Deze code is verlopen
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
